import z from "zod";

import usStates from "../../../vendor/us-states";

export const UsStateCode = z.enum(usStates.map(({ code }) => code) as [(typeof usStates)[number]["code"]]);
export type UsStateCode = z.infer<typeof UsStateCode>;
